import React, { useState } from 'react';

interface OKomCheckboxProps {
    checked: boolean;
    children?: React.ReactNode;
    onChange?: (checked: boolean) => void; 
}

const OKomCheckbox: React.FC<OKomCheckboxProps> = ({ onChange, children, checked }) => {
    // Local state for the checkbox checked status
    const [isChecked, setIsChecked] = useState(checked);

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // Update local state
        setIsChecked(e.target.checked);

        // Call the onChange prop to notify the parent component
        if (onChange) {
            onChange(e.target.checked);
        }
    };

    return (
        <div>
            <label className="ods-checkbox">
                {/* v4 ODS sizes __checkmark via `width:20px;height:20px;flex-shrink:0`,
                    which only takes effect when the parent is flex. The __wrapper span
                    (display:inline-flex) is what gives the checkmark its dimensions —
                    without it the span collapses to zero width. */}
                <span className="ods-checkbox__wrapper">
                    <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                    />
                    <span className="ods-checkbox__checkmark"></span>
                    <span className="ods-checkbox__text">{children}</span>
                </span>
            </label>
        </div>
    );
};

export default OKomCheckbox;
